import { Spin } from "antd";
import * as React from "react";
import { useContext, useState } from "react";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { ServiceContext } from "src/services/provider/Service.provider";
import "./style.scss";
import { ExpenseDetailView } from './ExpenseDetailView';
import { ExpenseList } from './ExpenseList';
import { FindExpense } from './FindExpense/FindExpense';
import { IExpenseBasicInfo } from 'src/services/interfaces/Expense/IExpenseBasicInfo';
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { ExpenseStatusEnum } from 'src/services/Enum/ExpenseStatusEnum';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';

interface IWorkflowExpenseListProps {
  listStatus: ExpenseStatusEnum[];
  cardTitle: string;
  showScheduleDate?: boolean;
  dateHeader?: React.FC<{ expense: IExpenseDetail }>;
}

export const WorkflowExpenseList: React.FC<IWorkflowExpenseListProps> = ({
  listStatus,
  cardTitle,
  children,
  showScheduleDate,
  dateHeader,
}) => {
  const { expenseSearchService } = useContext(ServiceContext);

  const [loadingList, setLoadingList] = useState(false);
  const [shouldReloadList, setShouldReloadList] = useState(false);
  const [loadingExpenseDetail, setLoadingExpenseDetail] = useState(false);
  const [currentExpense, setCurrentExpense] = useState<IExpenseDetail>(undefined);
  const [expensesList, setExpensesList] = useState<IExpenseBasicInfo[]>([]);

  function updateList() {
    handleCurrentValue(undefined);
    setShouldReloadList(true);
  }

  function handleCurrentValue(value: IExpenseDetail) {
    setCurrentExpense(value);
  }

  function handleList(list: IExpenseBasicInfo[]) {
    setExpensesList(list)
  }

  function handleShouldReloadList(value: boolean) {
    setShouldReloadList(value);
  }

  function findSelectedTrade(expenseId: number) {
    expenseSearchService
      .getDetailById(expenseId)
      .then(setCurrentExpense)
      .catch(() => ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente."))
      .finally(() => setLoadingExpenseDetail(false));
  }

  return (
    <PbrCard className="default-tabs" title={cardTitle} bordered={false} style={{ width: "100%" }}>
      <div className="trade-container">
        <div className="left trade-search-list">
          <FindExpense
            onChangeCurrentValue={handleCurrentValue}
            onChangeList={handleList}
            setLoadingList={setLoadingList}
            listStatus={listStatus}
            shouldReloadList={shouldReloadList}
            onChangeShouldReloadList={handleShouldReloadList}
          />
          <ExpenseList
            loadingList={loadingList}
            expenseList={expensesList}
            onChangeCurrentValue={handleCurrentValue}
            setLoadingExpenseDetail={setLoadingExpenseDetail}
            showScheduleDate={showScheduleDate}
          />
        </div>
        {currentExpense && (
          <div className="right trade-info">
            <div className="wrapper">
              <Spin spinning={loadingExpenseDetail} tip="Carregando solicitações de pagamento...">
                <ExpenseDetailView
                  onChangeCurrentValue={handleCurrentValue}
                  dateHeader={dateHeader}
                  updateList={updateList}
                  currentExpense={currentExpense}
                  setLoading={setLoadingExpenseDetail}
                  loading={loadingExpenseDetail}
                  reloadExpense={findSelectedTrade}
                  children={children}
                />
              </Spin>
            </div>
          </div>
        )}
      </div>
    </PbrCard>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/WorkflowExpenseList.tsx